// Drawers module: cart + account open/close and Escape handling
// Define drawer functions immediately so inline handlers don't error
window.isCartOpen = function () {
  const drawer = document.getElementById("CartDrawer");
  if (!drawer) return false;
  return !drawer.classList.contains("hidden") && !drawer.hidden;
};

// RTL-aware cart drawer helpers
function cartDrawerTranslateOut(panel) {
  const isRTL = document.documentElement.dir === 'rtl';
  if (isRTL) {
    panel.style.transform = 'translateX(-100%)';
  } else {
    panel.style.transform = 'translateX(100%)';
  }
}
function cartDrawerTranslateIn(panel) {
  panel.style.transform = 'translateX(0)';
}

window.restoreCartOpen = function () {
  const drawer = document.getElementById("CartDrawer");
  const panel = document.getElementById("CartDrawerPanel");
  const overlay = document.getElementById("CartOverlay");
  if (!drawer || !panel) return;
  drawer.classList.remove("hidden");
  drawer.hidden = false;
  cartDrawerTranslateIn(panel);
  if (overlay) { overlay.classList.remove("hidden"); overlay.hidden = false; }
  document.body.style.overflow = "hidden";
  const toggle = document.getElementById("CartToggle");
  if (toggle) toggle.setAttribute("aria-expanded", "true");
};

window.openCart = function () {
  const drawer = document.getElementById("CartDrawer");
  const panel = document.getElementById("CartDrawerPanel");
  const overlay = document.getElementById("CartOverlay");
  if (!drawer || !panel) return;
  // Set initial off-screen position before showing
  cartDrawerTranslateOut(panel);
  drawer.classList.remove("hidden");
  drawer.hidden = false;
  if (overlay) { overlay.classList.remove("hidden"); overlay.hidden = false; }
  document.body.style.overflow = "hidden";
  requestAnimationFrame(() => {
    requestAnimationFrame(() => cartDrawerTranslateIn(panel));
  });
  setTimeout(() => {
    if (typeof window.enableFocusTrap === "function") window.enableFocusTrap(panel);
  }, 50);
  const toggle = document.getElementById("CartToggle");
  if (toggle) toggle.setAttribute("aria-expanded", "true");
};

window.closeCart = function () {
  const drawer = document.getElementById("CartDrawer");
  const panel = document.getElementById("CartDrawerPanel");
  const overlay = document.getElementById("CartOverlay");
  if (!drawer || !panel) return;
  cartDrawerTranslateOut(panel);
  document.body.style.overflow = "";
  if (typeof window.disableFocusTrap === "function") window.disableFocusTrap();
  setTimeout(() => {
    drawer.classList.add("hidden");
    drawer.hidden = true;
    if (overlay) { overlay.classList.add("hidden"); overlay.hidden = true; }
  }, 300);
  const toggle = document.getElementById("CartToggle");
  if (toggle) toggle.setAttribute("aria-expanded", "false");
};

  window.openAccount = function () {
    const drawer = document.getElementById("AccountDrawer");
    const panel = document.getElementById("AccountDrawerPanel");
    const overlay = document.getElementById("AccountOverlay");
    if (!drawer || !panel) return;
    drawer.classList.remove("hidden");
    drawer.hidden = false;
    if (overlay) {
      overlay.classList.remove("hidden");
      overlay.hidden = false;
    }
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => panel.classList.remove("translate-x-full"));
    setTimeout(() => {
      if (typeof window.enableFocusTrap === "function") window.enableFocusTrap(panel);
    }, 50);
    const toggle = document.getElementById("AccountToggle");
    if (toggle) toggle.setAttribute("aria-expanded", "true");
  };
  window.closeAccount = function () {
    const drawer = document.getElementById("AccountDrawer");
    const panel = document.getElementById("AccountDrawerPanel");
    const overlay = document.getElementById("AccountOverlay");
    if (!drawer || !panel) return;
    panel.classList.add("translate-x-full");
    document.body.style.overflow = "";
    if (typeof window.disableFocusTrap === "function") window.disableFocusTrap();
    setTimeout(() => {
      drawer.classList.add("hidden");
      drawer.hidden = true;
      if (overlay) {
        overlay.classList.add("hidden");
        overlay.hidden = true;
      }
    }, 300);
    const toggle = document.getElementById("AccountToggle");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
  };
// Close on Escape for search modal or cart/account drawers
document.addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;
  const search = document.getElementById("SearchModal");
  if (search && !search.classList.contains("hidden")) {
    if (window.closeSearch) return window.closeSearch();
    return;
  }
  const cart = document.getElementById("CartDrawer");
  if (cart && !cart.classList.contains("hidden")) {
    closeCart();
    return;
  }
  const account = document.getElementById("AccountDrawer");
  if (account && !account.classList.contains("hidden")) {
    closeAccount();
  }
});
